export const cellTypeStyle = {
  padding: '6px 2px',
  textAlign: 'center',
  width: '7%'
}

export const cellNameStyle = {
  padding: '8px 4px',
  width: '19%',
  maxWidth: '19%'
}

export const cellRegionStyle = {
  padding: '4px 2px',
  textAlign: 'center',
  width: '5%'
}

export const cellDateStyle = {
  padding: '8px 4px',
  width: '14%'
}

export const cellRedeemStyle = {
  padding: '8px 4px',
  width: '12%'
}

export const cellTicketsStyle = {
  padding: '8px 4px',
  width: '15%'
}

export const cellCostStyle = {
  padding: '4px 2px',
  textAlign: 'center',
  width: '6%'
}

export const cellStatusStyle = {
  padding: '8px 4px',
  width: '8%'
}

export const cellActionsStyle = {
  padding: '2px',
  textAlign: 'center',
  width: '2%'
}
